module.exports = __webpack_public_path__ + "static/media/circulo_4A6700.ed5b7332.svg";